function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEditOutlinedi = function SvgEditOutlinedi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M13.466 7.097a.7.7 0 0 0-.237-.159.75.75 0 0 0-.56 0 .7.7 0 0 0-.237.159L3.14 16.389a.73.73 0 0 0-.209.437l-.427 3.863a.7.7 0 0 0 .035.316.74.74 0 0 0 .166.272.74.74 0 0 0 .266.175c.1.038.208.054.315.046l3.685-.285a.72.72 0 0 0 .461-.211l9.452-9.452a.7.7 0 0 0 .159-.237.75.75 0 0 0 0-.56.7.7 0 0 0-.159-.237zM4.355 17.24l-.3 2.732 2.535-.2 8.745-8.744-2.38-2.381zm10.4-12.5a.73.73 0 0 0-.214.518.73.73 0 0 0 .214.517l3.451 3.442a.73.73 0 0 0 1.033 0l2.025-2.025a.7.7 0 0 0 .159-.237.75.75 0 0 0 0-.56.7.7 0 0 0-.159-.237l-3.446-3.446a.7.7 0 0 0-.237-.159.75.75 0 0 0-.56 0 .7.7 0 0 0-.237.159zm1.551.516 2.416 2.411.993-.992-2.414-2.413z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEditOutlinedi);
export default ForwardRef;